import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { default as Select, components }  from "react-select";
import $ from "jquery";
import * as ReactDOM from 'react-dom';
import "datatables.net";
import {getFilenameFromURL,getUsername,formatDate} from "../../utils/common_functions"
import {API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE} from "../../utils/config_mapping"
import CommonIcon from '../common/customicon';
import PageLoader from '../common/pageloader';
import ProcessLoader from '../common/processloader';
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import {getAllClauses,createClause,deleteClause,updateClause,getClauseDescriptionByName} from "../../services/admin"
import Message from "../common/message";
import Error from "../common/error";


let clauseNameCheck;

export const Clauses = () => {
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const [addclausemodal, setAddClausesModal] = useState(false);
  const handleClose = () => { setAddClausesModal(false); $('body').trigger('click');
  };
  const handleShow = () => setAddClausesModal(true);
  const [deletedocumentmodal, setDeleteClausesModal] = useState(false);
  const handleDeleteClose = () => setDeleteClausesModal(false);
  const handleDeleteShow = () => setDeleteClausesModal(true);
  const [loading, setLoading] = useState(true); // State to track loading
  const [data, setData] = useState([]); // State to hold API data
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [saveLoader,setSaveLoader] = useState("");
  const [filters, setFilters] = useState({
  filterstatus: null,
  filterTextSearch: ""
});

  const initialState = {
    clauseName:"",
    clauseDescription:"",
    clauseId:""
  }

  const [isClauseDescLoading, setIsClauseDescLoading] = useState(false);


  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

   const handleDelete = async (event) => {
      const dataId = event.target.getAttribute('data-id');
      const targetElement = document.getElementById("app_err");
      if(dataId){
        try {
            const result = await deleteClause(dataId);
            if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CODE) {
                handleDeleteClose()
                fetchData();
                if (targetElement) {
                  ReactDOM.unmountComponentAtNode(targetElement);
                }
                  ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
                
              }
            }
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      }
    };

    const handleSaveClause = async (pmData) => {

        const targetElement = document.getElementById("app_err");
        setSaveLoader(true)
        if(pmData.clauseId===""){
          const result = await createClause(pmData);
          if (result.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
            fetchData();
            handleClose()
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
            

          } else {
            const targetElementerror = document.getElementById("uploaderror");
            if (targetElementerror) {
              ReactDOM.unmountComponentAtNode(targetElementerror);
            }
            ReactDOM.render(<Error message={result.error.message} />,targetElementerror)
            setSaveLoader(false)


            //               $("#uploaderror").html(`<div class="">
//     <div class="alert alert-danger d-flex align-items-start p-1 rounded-3 shadow-sm" role="alert">
//         <div class="me-2">
//             <i class="bi bi-x-circle-fill text-danger fs-5"></i>
//         </div>
//         <div class="flex-grow-1">
//             <div class="d-flex justify-content-between align-items-center">
//               <strong>   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg> `+result.error.message+`</strong>
//                 <!--<small class="text-muted">Dec 15, 2024 09:07</small>-->
//             </div>
//             <!--<div class="mt-2">
//                 <p class="mb-1"><strong>Code:</strong> DB_001</p>
//                 <p class="mb-1">Unable to establish connection with the primary database server</p>
//                 <p class="mb-0"><strong>Source:</strong> Database Service</p>
//             </div>-->
//         </div>
//     </div>
// </div>`)
//            ReactDOM.render(<Message type='error' message={result.data.message} />, targetElement);
            console.warn("Unexpected response status:", result.status);
          }
        }else{
          const result = await updateClause(pmData.clauseId,pmData);
          if (result.code === API_SUCCESS_RESPONSE_CODE) {
            fetchData();
            handleClose()
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
            setSaveLoader(false)
          } else {
            const targetElementerror = document.getElementById("uploaderror");
            if (targetElementerror) {
              ReactDOM.unmountComponentAtNode(targetElementerror);
            }
            ReactDOM.render(<Error message={result.error.message} />,targetElementerror)
            setSaveLoader(false)
          }
        }
        
    };

    const fetchData = async () => {
      $(".page_pro_load").hide();
      setLoading(true); // Stop loading spinner
      try {
        const result = await getAllClauses();
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
         setData(result.data);
         setFilteredData(result.data); // Set initial data for filtering
        } else {
          console.warn("Unexpected response status:", result.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
         setLoading(false); // Stop loading spinner
     }
    };
 useEffect(() => {
      fetchData();
 }, []); // Empty dependency array ensures this runs only once


  useEffect(() => {
    if (filteredData.length > -1) {
      const table = $("#contract_grid").DataTable({
        scrollCollapse: true,
        scrollX: true,
        pageLength: 25, // Set default number of records per page
       // scrollY: $(window).height()-($("#table_height").height()+180),
        data: filteredData,
        destroy: true, // Ensure the previous table is destroyed
        order: [],  // This disables default sorting on any column
        columnDefs: [
          { 
            targets: '_all', // Left-align all other columns
            className: 'text-left' // Bootstrap's text-left class
          }
        ],
        columns: [
         
          { data: "clauseName", title: "Clause Name",width: "40px", },
          { data: "clauseDescription", title: "Clause Description",width: "40px", },
          // { data: "clauseType", title: "Clause Type",width: "40px", },
          { data: "createdBy", title: "Created By",width: "40px", },
          // { data: "createdAt", title: "Created At",width: "40px", },
          { data: "createdAt", title: "Created Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", width: "150px",className: "text-left", // Add this to left-align the date column
          },

            {
              data: "taxonomyName", // Field name from your data
              title: "Taxonomy Names",
              width: "40px",
              render: function (data, type, row) {
                if (data) {
                  return data
                }else {
                  return "-"
                }
              }},
          {
            title: "Actions",
            orderable: false, // Disable sorting for this column
            data: null,
            width: "60px", 
            createdCell: function (td, cellData, rowData, row, col) {
              // Clear the default HTML and replace it with React-rendered content
              ReactDOM.render(
                <>
                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    overlay={<Tooltip id="view-top">Edit</Tooltip>}
                  >
                    <a href="javascript:void(0);" className="view-btn" data-id={rowData._id} data-name={rowData.clauseName} data-desc={rowData.clauseDescription}>
                      <i className="datatable-pencil-icon"></i>
                    </a>
                  </OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    placement="top"
                    overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                  >
                  <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                     data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.clauseName} data-taxonomynamelist={rowData.taxonomyName} >
                    <i className="datatable-delete-icon"></i>
                  </a></OverlayTrigger>
                  &nbsp;
                </>,
                td // Render the content directly into the table cell
              );
            }
          }
                 ],
        fixedColumns: {
          start: 1,
          end: 1
      },
        paging: true,
        searching: false,
        ordering: true,
        responsive: true,
        fixedHeader: true,
        language: {
          emptyTable: "No data found matching the filters",  // Custom message for no data
        },
      });

      $('.menu-icon').on('click', function() {
        // Adjust DataTable columns and redraw when the sidebar menu is toggled
        setTimeout(function() {
          table.columns.adjust().draw();
        }, 100); // Adjust the delay time based on your sidebar transition duration
      });


      $("#contract_grid").on("click", ".view-btn", function () {
        const id = $(this).data("id");
        const name = $(this).data("name");
        const desc = $(this).data("desc");
        const editState = {
          clauseName:name,
          clauseDescription:desc,
          clauseId:id
        }
        setFormData(editState); // Reset form fields to initial state
        handleShow()
        setSaveLoader(false)
      });

      $("#contract_grid").on("click", ".delete-btn", function () {
        handleDeleteShow()
        const id = $(this).data("id");
        const name = $(this).data("name");
        const taxonomynamelist = $(this).data("taxonomynamelist");
        setTimeout(function() {
          $("#btn_delete").attr("data-id", id);
          $("#document_name").html(name);
          if(taxonomynamelist===undefined){
            $("#not_tax_name").html("")
          }else {
            $("#not_tax_name").html("Note: This clause is associated with '"+taxonomynamelist+"' Taxonomies.")
          }
        }, 200);
       });

      return () => {
        table.destroy(); // Clean up DataTable instance
      };
    }
  }, [filteredData]);

    // Search handler
    const handleSearch = (e) => {
      setSearchQuery(e.target.value);
      applyFilters(e.target.value, filters);
    };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.clauseName) newErrors.clauseName = "Clause name  is required.";
    // if (!formData.clauseDescription) newErrors.clauseDescription = "Clause description  is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputBlur = async (e) => {
    // Action when the input loses focus
    if (formData.clauseName.trim() !== "" && formData.clauseId==="" && clauseNameCheck !== formData.clauseName.trim())  {
      setIsClauseDescLoading(true)
      clauseNameCheck = formData.clauseName.trim()
    const result = await getClauseDescriptionByName(formData.clauseName.trim());
    if (result.code === API_SUCCESS_RESPONSE_CODE) {
      // Extract the clauseDescription
      const clauseDescription = result.data.clauseDescription;
      let description = "";
        if (clauseDescription.includes("Description:")) {
            const parts = clauseDescription.split("Description:");
            description = parts[1]?.trim(); // Extract the part after "Description:" and trim whitespace
        }else {
          description = clauseDescription
        }


      
      const editState = {
        clauseName:formData.clauseName,
        clauseDescription:description,
        clauseId:formData.clauseId
      }

      setFormData(editState); // Reset form fields to initial state
      setIsClauseDescLoading(false)
    }
    } 
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const resetForm = (e) => {
    handleShow()
    setFormData(initialState); // Reset form fields to initial state
    setSaveLoader(false)
  }

  const handleSubmit = (e) => {
    const logged_user_name = getUsername();
    e.preventDefault();
    // if (isClauseDescLoading) {
    //   let targetElement = document.getElementById("app_err");
    //   if (targetElement) {
    //               ReactDOM.unmountComponentAtNode(targetElement);
    //             }
    //               ReactDOM.render(<Message type='info' message={"Form submission is blocked while fetching Clause Description."} />, targetElement);
    //     return;
    //   }
    if (!validateForm()) return;
    $(".page_pro_load").show();
    formData.clauseType = "List"
    formData.taxonomyIds = [];
    if(saveLoader!==true){
      handleSaveClause(formData)
    }

  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prevState) => {
      const newFilters = { ...prevState, [filterName]: value };
      applyFilters(newFilters);
      return newFilters;
    });
  };

  const applyFilters = (newFilters) => {
    let filteredDataTemp = data;
    if (newFilters.filterTextSearch) { // New filter for text search
      filteredDataTemp = filteredDataTemp.filter((doc) => 
        doc.clauseName.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.clauseDescription.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.clauseType.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.createdBy.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.createdAt.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())  ||
        doc._id.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.taxonomyName.some(taxonomy => 
          taxonomy.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())
      )
            );
    }
    setFilteredData(filteredDataTemp);
  };

  const resetFilters = () => {
    setSearchQuery('');
    setFilters({
      filterdocumentType: null,
      filterlicensor: null,
      filterexpiryDate: '',
      filterstatus: null
    });
    setFilteredData(data); // Reset to full data
  };


  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
          <div className="flex-grow-1" id="row_heading">
            <div className="page-title">Contract Clauses</div>
            <p className="text-muted my-2 ff-secondary">
            Manage and organize standard contract clauses
            </p>
            <div id="app_err"></div>
          </div>

          { data.length > 0 ? 
          <div className="row g-2 mb-4 mt-4" id="row_search">
            <div className="col-sm-10">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  id="searchClausess"
                  placeholder="Search Clausess..."  // This should work as expected
                  onChange={(e) => handleFilterChange('filterTextSearch', e.target.value)}
                />
                <i className="grid-search">
                <CommonIcon iconName="Search" size={"14px"}  />
                </i>
              </div>
            </div>
            <div className="col-sm-auto ms-auto">
              <div className="list-grid-nav hstack gap-1">
                <button className="btn btn-light" onClick={fetchData}>
                <CommonIcon iconName="RefreshCw" size={"14px"} color={"#000"} />
                </button>
                <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Plus" size={"14px"} color="#fff" /> Add Clause
                </button>
              </div>
            </div>
          </div> : "" }

      <div className="row d-none" id="row_filter" >
      <div className="col-lg-1 mt-2">
      <CommonIcon iconName="Filter" size={"14px"}  /> Filters:
      </div>
      <div className="col-lg-3">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterdocumentType}
            onChange={(selectedOption) => handleFilterChange('filterdocumentType', selectedOption)}
            options={documentTypeOptions}
            placeholder="Clauses Type"
          /> */}
      </div>
      <div className="col-lg-3">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterlicensor}
            onChange={(selectedOption) => handleFilterChange('filterlicensor', selectedOption)}
            options={licensorOptions}
            placeholder="Licensor"
          /> */}
      </div>
      <div className="col-lg-3 mb-2">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterstatus}
            onChange={(selectedOption) => handleFilterChange('filterstatus', selectedOption)}
            options={statusoptions}
            placeholder="Status"
          /> */}
          </div>
      </div>
      </div>
          <div className="row">
            <div className="col-lg-12">
                  <div>
                    {/* DataTable */}
                    {loading ? (
                 <PageLoader />
            ) :  data.length > 0 ?
                (
                <div className="row  mt-4">
                  <div className="col-lg-12">
                    <table
                      id="contract_grid"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                  </div>
                </div>) : <div className="mt-5 card"><div className="text-center">
      <div className="no-doc-container my-4">
        {/* Bootstrap file-earmark icon with a warning sign */}
        <CommonIcon iconName="FileText" width="50" height="50" />
        <div className="mt-3">
          <i className="bi bi-exclamation-circle-fill text-danger"></i>
        </div>
      </div>
      <h4 className="text-muted mb-4">No Clause Found</h4>
      <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal mb-4"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Plus" size={"14px"} color="#fff" /> Add Clause
                </button>
                <br/>
                <br/>
    </div>
    </div> }
                  </div>
                </div>
              </div>
            {/* </div>
          </div> */}
        </div>
      </div>

      <Modal show={deletedocumentmodal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" id="confirmationModalLabel">
                Delete
              </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label class="form-label">Are you sure want to delete <span id="document_name"></span> clause?</label>
         <p id="not_tax_name" className="bold"></p>
          </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleDeleteClose} className="btn btn-light" data-bs-dismiss="modal"><CommonIcon iconName="X" size={"14px"} /> Close</button>
                  <button onClick={handleDelete} id="btn_delete" data-id="1111" type="submit" className="btn btn-primary">
                    <CommonIcon iconName="Trash" size={"14px"} color="#fff" /> Delete
                  </button>
        </Modal.Footer>
      </Modal>

      <Modal show={addclausemodal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> 
                  {formData.clauseId==="" ? "Create New Clause" : "Edit Clause"}
           </Modal.Title>
           <p className="modal-desc">
           {formData.clauseId==="" ? "Create a new standard clause template to your contract library" : "Edit clause template to your contract library"}
            </p>
        </Modal.Header>
        <Modal.Body>
        <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">Clause Name</label>
                    <input type="hidden" name="clauseId" value={formData.clauseId} />
                    <input
                      type="text"
                      name="clauseName"
                      className={formData.clauseId==="" ? "form-control" : "form-control-plaintext"}
                      value={formData.clauseName}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur} // Focus out event handler
                      placeholder="Enter clause name"
                      //readOnly={formData.clauseId==="" ? false : true}
                    />
                    {errors.clauseName && <div className="text-danger">{errors.clauseName}</div>}
                  </div>

                  <div className="col-lg-12">
                <label className="form-label">Clause Description</label>
                <div style={{ position: "relative" }}>
                  {/* Textarea */}
                  <textarea
                    name="clauseDescription"
                    id="clauseDescription"
                    rows="5"
                    cols="40"
                    className="form-control"
                    value={formData.clauseDescription}
                    onChange={handleInputChange}
                    placeholder="Enter clause description..."
                    disabled={isClauseDescLoading} // Disable textarea while loading
                    style={{
                      background: isClauseDescLoading ? "rgba(255, 255, 255, 0.7)" : "inherit", // Dim background while loading
                    }}
                  ></textarea>

                  {/* Loader */}
                  {isClauseDescLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                        pointerEvents: "none", // Prevent loader from blocking interactions
                      }}
                    >
                      <div style={{height:"20px",width:"20px"}} className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                {errors.clauseDescription && (
                  <div className="text-danger">{errors.clauseDescription}</div>
                )}
              </div>
                <div className="page_pro_load mb-2">{
                <ProcessLoader pmMessage={"PDF upload in progress, please wait..."}  />
                }</div>
                <div id="uploaderror"></div>
                </div>
              </form>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleClose} className="btn btn-light" data-bs-dismiss="modal"><i className="ri-close-line align-bottom me-1"></i> Close</button>
              <button 
              disabled={(formData.clauseId==="" && formData.clauseName!=="" && errors.clauseName!==undefined &&  errors.clauseName==="") || formData.clauseId!==""  ? "" : "true"} 
              onClick={handleSubmit} type="submit" className="btn btn-primary">
              {saveLoader === true ? <span className="submit-loader"></span> : ""}
                    {formData.clauseId==="" ? "Create Clause" : "Update Clause"}
               </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};